import Backbone from 'backbone'
import _ from 'lodash'
import template from './view-table-data-source.hbs'
import unwrapModel from 'scoreboard/components/unwrap-model'
import DataSourceLink from 'scoreboard/components/data-source-selector/data-source-link'

const ViewTableDataSource = Backbone.View.extend(/** @lends {ViewTableDataSource} */{

	className: 'view-table-data-source',

	/**
	 * The "View Data Source" option for a dataset table. Created in #41332
	 *
	 * @constructs
	 *
	 * @param {Dataset} options.model
	 *
	 * @param {DatasetTable} options.table
	 *
	 * @param {Boolean} [options.showDatasetLink=true]
	 */
	initialize: function(options = {}) {
		this.options = options
		this.showDatasetLink = _.get(options, 'showDatasetLink', true)
	},

	events: {
		'click .done': 'onClickDone'
	},

	render: function() {
		this.$el.html(template(this.context()))
		this.renderDataSourceLink()
		if (!this.showDatasetLink) {
			this.$('.dataset-label').addClass('is-not-displayed')
		}
		return this
	},

	context: function() {
		let table = unwrapModel(this.options.table)
		let vlf = this.model.visibleLinkedFieldsById[table.visibleLinkedFieldId]
		let fieldLabelTextKey, fieldName
		if (vlf) {
			fieldLabelTextKey = 'datasets.linkedField'
			fieldName = vlf.label
		} else {
			fieldLabelTextKey = 'datasets.field'
			let field = this.model.combinedFieldsById[table.fieldId]
			fieldName = field.label
		}

		return {
			fieldName,
			fieldLabelTextKey,
			datasetLabel: _.get(this.model.attributes, 'label'),
			href: `datasets/${_.get(this.model.attributes, 'id')}`
		}
	},

	renderDataSourceLink: function() {
		this.dataSourceLink = new DataSourceLink({
			id: this.model.id,
			section: 'datasets',
			label: this.model.get('label')
		})
		this.$('.dataset-label').append(this.dataSourceLink.el)
		this.dataSourceLink.render()
	},

	onClickDone: function() {
		this.trigger('done')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.dataSourceLink], 'remove')
	}

})

export default ViewTableDataSource

ViewTableDataSource.__filename__ = 'datasets/overview/view-table-data-source.js'
